import { ChangeDetectorRef, Component } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { timer } from 'rxjs';
import { LoadingService } from './_services/loading.service';
import { MessageService } from './_services/message.service.';
import { CustomMessageModel } from './_shared/custom-message/custom-message-model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  
  loading: boolean = false;
  loadingService: LoadingService;
  loadingSubscription: any;

  messageModel: CustomMessageModel = {} as CustomMessageModel;
  messageService: MessageService;
  messageSubscription: any;

  constructor(
    loadingService: LoadingService,
    messageService: MessageService,
    
    private cdref: ChangeDetectorRef,
    private router: Router) {
    this.loadingService = loadingService;
    this.messageService = messageService;

    this.loadingRouterControl();
    this.initMessageService();
    
  }

  ngOnInit() {
    this.initLoadingService();
    this.initMessageService();
  }

  initLoadingService() {
    this.loadingSubscription = this.loadingService.getEmittedValue()
      .subscribe(item => {
        this.loading = item
        this.cdref.detectChanges();
      });
  }

  initMessageService() {
    this.messageSubscription = this.messageService.getEmittedValue()
      .subscribe(item => {
        if (item.show && item.timer > 0) {
          const numbers = timer(item.timer);
          numbers.subscribe(x => this.messageService.hide());
        }

        this.messageModel = item

        this.cdref.detectChanges();
      });
  }

  loadingRouterControl() {
    this.router.events.subscribe((event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.loading = true;
          break;
        }
        case event instanceof NavigationCancel:
        case event instanceof NavigationEnd:
        case event instanceof NavigationError: {
          this.loading = false;
          window.scrollTo(0, 0);
          this.updateDriverPortalZoom();
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  private updateDriverPortalZoom(): void {
    // O portal do motorista não usa o zoom global aplicado ao sistema administrativo.
    const isDriverPortal = this.router.url.startsWith('/app');

    document.documentElement.classList.toggle('driver-portal', isDriverPortal);
    document.body.classList.toggle('driver-portal', isDriverPortal);
  }

  get loadingColorPrimary() {
    return '#000';
  }

  get loadingColorSecondary() {
    return '#F0F2F3';
  }

  get loadingColorTertiary() {
    return '#717171';
  }
}
